/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type ItemStatus_item$ref = any;
export type ItemStatus_item = {
    readonly isOnHold: boolean | null;
    readonly isSold: boolean | null;
    readonly hasRequestedHoldForBuyer: boolean | null;
    readonly activeHold: {
        readonly expirationDate: string | null;
    } | null;
    readonly " $refType": ItemStatus_item$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "ItemStatus_item",
    "type": "Item",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "userId",
            "type": "String!"
        }
    ],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "isOnHold",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "isSold",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "hasRequestedHoldForBuyer",
            "args": [
                {
                    "kind": "Variable",
                    "name": "buyerId",
                    "variableName": "userId"
                }
            ],
            "storageKey": null
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "activeHold",
            "storageKey": null,
            "args": null,
            "concreteType": "Hold",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "expirationDate",
                    "args": null,
                    "storageKey": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = '70d97d13f92a095bb3bb82cbe69938dc';
export default node;
